<script context="module">
  // context="module" makes this exportable
  export const IMAGE_WIDTH = 230;
  export const IMAGE_HEIGHT = 100;
</script>

<script>
  // Props
  export let id;
  export let description;
  export let url;

  // Constants
  const IMAGE_DIMENSIONS = {
    WIDTH: IMAGE_WIDTH,
    HEIGHT: IMAGE_HEIGHT,
  };
  const IMAGE_FORMATS = ['avif', 'webp'];
</script>

<picture>
  {#each IMAGE_FORMATS as format}
    <source srcset={`${url}?fm=${format}`} type="image/{format}" />
  {/each}
  <img
    {id}
    class="SpotlightImage"
    loading="lazy"
    alt={description}
    src={url}
    style:height="{IMAGE_DIMENSIONS.HEIGHT}px"
    style:width="{IMAGE_DIMENSIONS.WIDTH}px"
  />
</picture>

<style>.SpotlightImage {
  max-width: none;
  border-radius: 6px;
}</style>
